import { HELP_ICON_HTML } from '../../tourUi'
import { buildNovoExportacaoFormSteps } from './exportacaoTourSteps'

const LISTA_READY_SELECTOR = '[data-tour="exportacao-novo"]'
const FORM_READY_SELECTOR = '[data-tour="exportacao-form-root"][data-carregado="true"]'
const FORM_START_INDEX = 2
const NOVO_STEP_INDEX = 1

const openNovoExportacao = (tourManager) => {
    tourManager.navigateAndWait('/exportacao-dados/novo', FORM_READY_SELECTOR, FORM_START_INDEX, 'novo-exportacao-dados')
        .then(() => tourManager.moveTo(FORM_START_INDEX))
        .catch(() => {})
}

const bindNovoExportacaoClick = (element, tourManager) => {
    const button = element?.matches?.('[data-tour="exportacao-novo"]')
        ? element
        : document.querySelector('[data-tour="exportacao-novo"]')

    if (!button || button._hdvNovoExportacaoClick) return

    const onClick = (event) => {
        event.preventDefault()
        event.stopPropagation()
        event.stopImmediatePropagation?.()
        openNovoExportacao(tourManager)
    }

    button.addEventListener('click', onClick, true)
    button._hdvNovoExportacaoClick = onClick
}

const unbindNovoExportacaoClick = (element) => {
    const button = element?.matches?.('[data-tour="exportacao-novo"]')
        ? element
        : document.querySelector('[data-tour="exportacao-novo"]')

    if (!button?._hdvNovoExportacaoClick) return

    button.removeEventListener('click', button._hdvNovoExportacaoClick, true)
    delete button._hdvNovoExportacaoClick
}

const buildNovoExportacaoTourSteps = (tourManager) => [
    {
        popover: {
            title: 'Exportação de Dados',
            description: `A Exportação de Dados permite criar modelos de planilha para organizar e exportar informações da plataforma.<br><br>Após salvar, edite o cadastro e clique novamente no ícone de <strong>Ajuda</strong> ${HELP_ICON_HTML} para continuar com o guia de configuração da planilha.`,
            side: 'over',
            align: 'center',
        },
    },
    {
        element: '[data-tour="exportacao-novo"]',
        ensureReady: () => tourManager.waitForElement(LISTA_READY_SELECTOR),
        popover: {
            title: 'Novo modelo',
            description: 'Clique em <strong>Próximo</strong> para abrir o cadastro de uma nova exportação.',
            side: 'bottom',
            align: 'start',
            onNextClick: () => openNovoExportacao(tourManager),
        },
        onHighlighted: (element) => bindNovoExportacaoClick(element, tourManager),
        onDeselected: (element) => unbindNovoExportacaoClick(element),
    },
    ...buildNovoExportacaoFormSteps(tourManager, { indiceNovoStep: NOVO_STEP_INDEX }),
]

export default buildNovoExportacaoTourSteps
